import zipcodeService from './zipcodeService';
import Zipcode, {defaultConfig} from './Zipcode';

export {
	zipcodeService as zipcodeService,
	defaultConfig
}
export default Zipcode;